import script from "./ReceivedReportFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./ReceivedReportFilter.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/pc/received.css?vue&type=style&index=0&id=70f89fd2&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70f89fd2"]])

export default __exports__